import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6" }

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import DropdownCard from '@/components/designSystem/Cards/DropdownCard.vue'
import TeamExchangeConfigBlock from '@/components/designSystem/modals/EditScheduleModal/tabs/TeamExchangeConfigBlock.vue'
import { SCHEDULE_SECTION_LABELS } from '@/constants/schedule-sections.constants'
import ScheduleStepHeading from './ScheduleStepHeading.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeConfigForm',
  props: {
    errors: {},
    onClearError: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const store = useCreateScheduleStore()
const { stepExchangeConfig } = storeToRefs(store)

function scopeErrors(all: Record<string, string>, team: string): Record<string, string> {
  const prefix = `${team}.`
  const out: Record<string, string> = {}
  for (const [key, value] of Object.entries(all)) {
    if (key.startsWith(prefix)) out[key.slice(prefix.length)] = value
  }
  return out
}

const ourTeamErrors = computed(() => scopeErrors(props.errors, 'ourTeam'))
const notOurTeamErrors = computed(() => scopeErrors(props.errors, 'notOurTeam'))
const clearOurTeamError = (field: string) => props.onClearError(`ourTeam.${field}`)
const clearNotOurTeamError = (field: string) => props.onClearError(`notOurTeam.${field}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ScheduleStepHeading, {
      title: _unref(SCHEDULE_SECTION_LABELS).exchangeConfig
    }, null, 8, ["title"]),
    _createVNode(DropdownCard, {
      title: "Nossa Equipe (Time Interno)",
      subtitle: "Médicos do seu time, contratados e gerenciados pela sua empresa.",
      "start-open": false,
      "test-id": "our-team-accordion-toggle",
      class: "border border-lightGray30"
    }, {
      default: _withCtx(() => [
        _createVNode(TeamExchangeConfigBlock, {
          config: _unref(stepExchangeConfig).ourTeam,
          errors: ourTeamErrors.value,
          "on-clear-error": clearOurTeamError,
          "testid-prefix": "our-team"
        }, null, 8, ["config", "errors"])
      ]),
      _: 1
    }),
    _createVNode(DropdownCard, {
      title: "Equipe da Unidade (Time Externo)",
      subtitle: "Médicos externos, vinculados à própria unidade de saúde.",
      "start-open": true,
      "test-id": "not-our-team-accordion-toggle",
      class: "border border-lightGray30"
    }, {
      default: _withCtx(() => [
        _createVNode(TeamExchangeConfigBlock, {
          config: _unref(stepExchangeConfig).notOurTeam,
          errors: notOurTeamErrors.value,
          "on-clear-error": clearNotOurTeamError,
          "testid-prefix": "not-our-team"
        }, null, 8, ["config", "errors"])
      ]),
      _: 1
    })
  ]))
}
}

})